import { render, staticRenderFns } from "./AnchoredVWAPSettings.vue?vue&type=template&id=57990022&scoped=true"
import script from "./AnchoredVWAPSettings.vue?vue&type=script&lang=js"
export * from "./AnchoredVWAPSettings.vue?vue&type=script&lang=js"
import style0 from "./AnchoredVWAPSettings.vue?vue&type=style&index=0&id=57990022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57990022",
  null
  
)

export default component.exports